/**
 * @param {number} total
 * @param {number} value
 * @return {number}
 */
export const getPercentInteger = (total, value) => {
  return Number((value * (100 / total)).toFixed(0)) || 0;
};
